import React, { useState, useEffect } from "react";
import AuthService from "../services/AuthService";

const SessionStatus = ({ onSessionExpired }) => {
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateSessionInfo = () => {
      if (AuthService.isAuthenticated()) {
        const remaining = AuthService.getSessionTimeRemaining();
        setTimeRemaining(remaining);

        // Show warning when less than 5 minutes remaining
        setIsVisible(remaining <= 5 && remaining > 0);

        // Session expired
        if (remaining === 0) {
          onSessionExpired?.();
        }
      } else {
        setIsVisible(false);
        onSessionExpired?.();
      }
    };

    // Update immediately
    updateSessionInfo();

    // Update every 30 seconds
    const interval = setInterval(updateSessionInfo, 30000);

    return () => clearInterval(interval);
  }, [onSessionExpired]);

  const handleExtendSession = () => {
    AuthService.extendSession();
    setTimeRemaining(30); // Reset to 30 minutes
    setIsVisible(false); // Hide warning
  };

  const handleLogout = () => {
    AuthService.logout();
    onSessionExpired?.();
  };

  if (!isVisible) {
    return null;
  }

  const getWarningColor = () => {
    if (timeRemaining <= 1) return "#dc3545"; // Red
    if (timeRemaining <= 3) return "#fd7e14"; // Orange
    return "#ffc107"; // Yellow
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        backgroundColor: "white",
        border: `2px solid ${getWarningColor()}`,
        borderRadius: "8px",
        padding: "15px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        zIndex: 1000,
        maxWidth: "300px",
        animation: "slideIn 0.3s ease-out",
      }}
    >
      <div style={{ marginBottom: "12px" }}>
        <div
          style={{
            fontWeight: "600",
            color: getWarningColor(),
            fontSize: "14px",
            marginBottom: "5px",
          }}
        >
          Sesiunea expira curand
        </div>
        <div style={{ color: "#666", fontSize: "13px" }}>
          Timp ramas:{" "}
          <strong>
            {timeRemaining} minut{timeRemaining !== 1 ? "e" : ""}
          </strong>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "8px",
          justifyContent: "flex-end",
        }}
      >
        <button
          onClick={handleLogout}
          style={{
            padding: "6px 12px",
            backgroundColor: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "4px",
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          Deconectare
        </button>
        <button
          onClick={handleExtendSession}
          style={{
            padding: "6px 12px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "4px",
            fontSize: "12px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Prelungeste (+30 min)
        </button>
      </div>

      <style jsx>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default SessionStatus;
